import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { utilizationAndCoverageDetailsDataSelector } from "./utilizationAndCoverageDetailsDataSelector";
import { SavingsPlanCoverageDataWithId } from "../../../../../../components/pages/commtiments/utilization-and-coverage/utils/types";
import { addIdInCoverageData } from "../../../../utils/helpers/addIdInCoverageData";

export const utilizationAndCoverageDetailsCoverageDataSelector =
  createDraftSafeSelector(
    [utilizationAndCoverageDetailsDataSelector],
    (data): SavingsPlanCoverageDataWithId[] | undefined => {
      return addIdInCoverageData(data?.coverage_data);
    },
  );
